document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-sp-promo]');
  if (!form) return;
  event.preventDefault();
  const code = form.elements.discount.value.trim();
  if (!code) return;
  const button = form.querySelector('button');
  const status = form.querySelector('[data-promo-status]');
  button.disabled = true;
  status.textContent = '';
  try {
    const currentResponse = await fetch(window.routes.cart_url + '.js');
    if (!currentResponse.ok) throw new Error();
    const current = await currentResponse.json();
    const codes = (current.discount_codes || []).filter(item => item.applicable).map(item => item.code);
    if (!codes.some(item => item.toLowerCase() === code.toLowerCase())) codes.push(code);
    const response = await fetch(window.routes.cart_update_url + '.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({discount: codes.join(','), sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname})
    });
    const cart = await response.json();
    if (!response.ok) throw new Error();
    const accepted = (cart.discount_codes || []).some(item => item.code.toLowerCase() === code.toLowerCase() && item.applicable);
    if (!accepted) { status.textContent = form.dataset.invalid; return; }
    if (form.dataset.context === 'page') { window.location.reload(); return; }
    const drawer = document.querySelector('cart-drawer');
    if (!cart.sections?.['cart-drawer']) { window.location.reload(); return; }
    drawer.renderContents(cart);
    const updated = drawer.querySelector('[data-sp-promo]');
    if (updated) {
      updated.closest('details').open = true;
      updated.querySelector('[data-promo-status]').textContent = form.dataset.success;
      updated.elements.discount.focus();
    }
  } catch (error) { status.textContent = form.dataset.error; }
  finally { button.disabled = false; }
});